/**
 * Check whether the string provided is a CSS variable
 *
 * @param cssVariable The string to be tested
 */
export function isCssVar(cssVariable) {
    return cssVariable.startsWith('--');
}
